// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.container[data-v-41fedc50] {\n  width: 95%;\n}\n.v-overlay[data-v-41fedc50] {\n  align-items: center;\n  justify-content: center;\n}\n.v-data-table[data-v-41fedc50] th,\n.v-data-table[data-v-41fedc50] .v-data-table-footer {\n  font-size: 12px !important;\n}\n.v-data-table[data-v-41fedc50] td {\n  font-size: 14px !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
